import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
/*const [saveResult, save, resetSaveResult, _busy] =
		GD.REQ_AUTH_REGISTER.useRequest();*/
import { Form } from "@ui/form/Form";
import { useState } from "react";
import { GD } from "src/GD";
import { S_AUTH_CHANGE_VIEW } from "./AuthSignals";
import { registrationForm, TAuthRegister } from "./RegisterView";

export const RegisterStep3 = () => {
	useLocale();
	const [formData, setFormData] = useState<TAuthRegister>(registrationForm.step3);

	const validate = (): boolean => {
		if (!registrationForm.step1.registration_number || registrationForm.step1.registration_number === "") {
			GD.REG_STEP_ERROR.invoke({
				step: "step3",
				error: {
					code: -1,
					message: msg("pleaseProvideRegistrationNumber"),
				},
			});
			return false;
		}

		return true;
	};

	const handleSubmit = async () => {
		if (validate()) {
			GD.REQ_STEP_BUSY.invoke(false);
			GD.REG_STEP_ERROR.invoke({
				step: "step3",
				error: null,
			});
			const response = await GD.REQ_API.request({
				method: "users/mail/check/request",
				data: {
					email: registrationForm.step2.email,
				},
			});
			GD.REQ_STEP_BUSY.invoke(false);

			if (response && response.data) S_AUTH_CHANGE_VIEW.invoke("reg4");
			else
				GD.REG_STEP_ERROR.invoke({
					step: "step3",
					error: response?.error ?? {
						code: -1,
						message: msg("unknownError"),
					},
				});
		}
	};

	//todo: request company check!

	return (
		<>
			{formData && (
				<Form
					sx={{ gap: "30px" }}
					data={formData}
					//error={saveResult}
					onSubmit={() => handleSubmit()}
					onChange={form => {
						registrationForm.step3 = form;
						setFormData(form);
					}}
					submitTitle="Continue"
					fullWidthButton
				/>
			)}
		</>
	);
};
